<template>
  <div class="stock-kline-view">
    <StockKLineWeek :stock-code.sync="stockCode" />
  </div>
</template>

<script>
import StockKLineWeek from '@/components/kline/StockKLineWeek.vue'

export default {
  name: 'StockKLineWeekView',
  components: {
    StockKLineWeek
  },
  data() {
    return {
      stockCode: 'sz.002602'
    }
  },
  created() {
    if (this.$route.query.code) {
      this.stockCode = this.$route.query.code
    }
  }
}
</script>

<style scoped>
.stock-kline-view {
  padding: 20px;
  flex: 1;
}
</style>
